interface GetCheckpointFromPathnameParams {
  pathname: string;
}

const getCheckpointFromPathname = ({
  pathname
}: GetCheckpointFromPathnameParams): string => {
  const matches = pathname.match(/^\/discoveries\/[^\/]+(\/[^\/]+)([^\/]+)?$/);

  return matches ? matches[1] : "";
};

export default getCheckpointFromPathname;
